/* @flow strict */

import * as React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';

type PropsType = {
  onHandleChangeStepNavBar?: () => void,
  handleSave: () => void,
  isNew?: boolean,
  isClone?: boolean,
  isEditNew?: boolean,
  text?: string,
  profileCurrent?: {}
};

export const SaveBtnRef = React.createRef();

class SaveBtn extends React.Component<PropsType> {
  props: PropsType;

  constructor(props: PropsType) {
    super(props);

    this.navbarActionEl = document.querySelector('.topNavBarActions');
    this.navbarActionElNext = document.querySelector('.topNavBarActions + div');
  }

  componentDidMount = () => {
    if (_.size(this.navbarActionEl)) {
      this.navbarActionEl.style.display = 'flex';
      this.navbarActionElNext.style.display = 'none';
    }
  };

  componentWillUnmount = () => {
    if (_.size(this.navbarActionEl)) {
      this.navbarActionEl.style.display = 'none';
      this.navbarActionElNext.style.display = 'flex';
    }
  };

  render = (): React.Element<'button'> => {
    const { isNew, isClone, isEditNew, profileCurrent, text } = this.props;
    const Component = (
      <button
        ref={SaveBtnRef}
        className="btn btn-pink saveBtnSelfCheckin"
        onClick={() => {
          this.props.handleSave(
            isNew,
            profileCurrent,
            this.props.onHandleChangeStepNavBar,
            isClone,
            isEditNew
          );
        }}
      >
        <span>{text}</span>
      </button>
    );

    if (_.size(this.navbarActionEl)) {
      return ReactDOM.createPortal(
        Component,
        this.navbarActionEl
      );
    }

    return null;
  }
}

export default SaveBtn;
